import { Injectable, OnDestroy } from '@angular/core';
import { AngularFire, FirebaseListObservable, FirebaseObjectObservable, firebaseAuthConfig, AuthProviders, AuthMethods } from 'angularfire2';
import { Page } from './models';
import { PageService, CalendarService, LessonsService, NavItemService, PodService,
         PromotionService, PushService, TestsService } from './helpers';

@Injectable()
export class ContentService implements OnDestroy {
  pages: PageService;
  events: CalendarService;
  lessons: LessonsService;
  navItems: NavItemService;
  pods: PodService;
  promotions: PromotionService;
  push: PushService;
  tests: TestsService;
  subscriptions: any[] = [];

  constructor(pages: PageService, events: CalendarService, lessons: LessonsService,
              navItems: NavItemService, pods: PodService, promotions: PromotionService,
              push: PushService, tests: TestsService) {
    this.pages = pages;
    this.events = events;
    this.lessons = lessons;
    this.navItems = navItems;
    this.pods = pods;
    this.promotions = promotions;
    this.push = push;
    this.tests = tests;
  }

  initialize(app: string) {
    this.pages.initialize(app);
    this.navItems.initialize(app);
    this.events.initialize(app);
    this.pods.initialize(app);
    this.promotions.initialize(app);
    this.push.initialize(app);

    this.subscriptions.push(this.pages.firebaseObservable.subscribe((pages: Page[]) => {
      this.navItems.updateNavItemsWithPages(this.pages.flatPages);
      this.events.updateEventsWithPages(this.pages.flatPages);
      this.pods.updatePodsWithPages(this.pages.flatPages);
      this.promotions.updatePromotionsWithPages(this.pages.flatPages);
      this.push.updateNotificationsWithPages(this.pages.flatPages);
    }));

    // Required so the values are loaded
    this.subscriptions.push(this.navItems.firebaseObservable.subscribe());
    this.subscriptions.push(this.events.firebaseObservable.subscribe());
    this.subscriptions.push(this.pods.firebaseObservable.subscribe());
    this.subscriptions.push(this.promotions.firebaseObservable.subscribe());
  }

  deletePage(page: Page) {
    if (page.type === 'folder') {
      page.pages.forEach((child) => {
        this.deletePage(child);
      });
    }
    this.navItems.updateNavItemsWithDeletedPage(page);
    this.events.updateEventsWithDeletedPage(page);
    this.pods.updatePodsWithDeletedPage(page);
    this.promotions.updatePromotionsWithDeletedPage(page);
    if (page.trainingType) {
      if (page.trainingType === 'lesson') this.lessons.deleteLesson(page.trainingID);
      else this.tests.deleteTest(page.trainingType, page.trainingID);
    }
    return this.pages.delete(page);
  }

  ngOnDestroy() {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}



// WEBPACK FOOTER //
// /app/src/app/shared/services/app/content/content.service.ts